import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  AfterViewInit,
  ElementRef
} from "@angular/core";
import { ModalService } from "../../utilities/modal/modal.service";
import { FinAppToolModalComponent } from "../finapp-tool-modal/finapp-tool-modal.component";
import { ExternalAccountsService } from "src/app/services/externalaccounts.service";
import { GenericService } from "../../services/generic.service";
import { AggregationService } from "../../services/aggregation.service";
import { WindowRefService } from "../../services/window-ref.service";
import { ThrowStmt } from '@angular/compiler';
/*
enum ProductType {
  Bank = 'bank',
  Investments = 'investments',
  Insurance = 'insurance',
  Debt = 'debt',
  Other = 'other'
}*/

declare var $: any;
@Component({
  selector: "aggregated-external",
  templateUrl: "./aggregatedexternal.component.html",
  styleUrls: ["./aggregatedexternal.component.scss"]
})
export class AggregatedexternalComponent implements OnInit, AfterViewInit {
  @ViewChild("finAppToolModal") finAppToolModal: FinAppToolModalComponent;
  @ViewChild("manageAccounts") manageAccounts: ElementRef;
  @Input() modalId: string;
  @Input() finAppName: string;
  @Output() closeModalEmitterFinApp = new EventEmitter<string>();
  manageBtn: string = "";
  externalAccountsByCategory: any;
  logOutFailed: boolean = false;
  prodTitles = ["bank", "investments", "insurance", "debt", "other"];
  finAppToolModalId = "finapp-tool-modal";
  aggProfileErrorMessage: any = null;
  loadingIndicator: boolean;
  constructor(
    private _modalService: ModalService,
    private _externalAccountsService: ExternalAccountsService,
    public _genericService: GenericService,
    private _aggregationService: AggregationService,
    private winRef: WindowRefService
  ) { }
  ngOnInit() {
    this.getAndSubscribeExtAccounts();
  }

  private getAndSubscribeExtAccounts() {
    this.loadingIndicator = true;
    this._externalAccountsService.extAgg$.subscribe(val => {
      if (
        val &&
        (val.bank || val.investments || val.insurance || val.debt || val.other)
      ) {
        this.externalAccountsByCategory = val;
        //console.log('data_new',this.externalAccountsByCategory);
        this.manageBtn =
          this.externalAccountsByCategory.focusArr
            .join()
            .indexOf(this.manageBtn) > -1
            ? this.manageBtn
            : "add";
        this.loadingIndicator = false;
      } else if (val && val === "empty") {
        this.externalAccountsByCategory = [];
        this.loadingIndicator = false;
      } else if (val && val === "error") {
        this.externalAccountsByCategory = null;
        this.loadingIndicator = false;
      } else {
        this.loadingIndicator = false;
      }
    });
    this._externalAccountsService.getExtAccountsData();
  }

  ngAfterViewInit() {
    // this._modalService.subscribeToHidden(this.finAppToolModalId).subscribe((r: any) => {
    //   if (r) {
    //     this.loadingIndicator = true;
    //   } else {
    //     this.loadingIndicator = false;
    //   }
    // });
  }

  convertNum(val) {
    let retVal: any = parseFloat(val).toString();
    if (retVal === "NaN") {
      retVal = 0.0;
    } else {
      retVal = parseFloat(retVal);
    }
    return retVal;
  }

  openSpecifiedModal(modalId: string, providerId?: any, id?: any) {
    this.manageBtn = null;
    this.manageBtn = id ? providerId + id : "add";
    this.aggProfileErrorMessage = null;
    //this.loadingIndicator = true;
    this.finAppToolModal.extraParams = providerId
      ? "siteAccountId=" + providerId + "&flow=edit"
      : "flow=standard-flow";
    if (modalId.includes(this.finAppToolModalId)) {
      this.finAppToolModal.openModal();
    } else {
      this._modalService.open(modalId);
    }
  }

  genericError(str?: string) {
    const msg = str || 'Sorry! Unable to launch the widget, please try again.';
    this.aggProfileErrorMessage = msg;
    // "Sorry! Unable to launch the widget, please try again.";
    this.loadingIndicator = false;
  }

  closeSpecifiedModal(modalId: string, eve?: any) {
    /* true is emitted at close of modal 
   'SUCCESS, INSTANCE_ERROR are type string events which are emitted once sync is done/failed scenario 
   loadIndicator is the flag we show on the container when we have event as true*/
    this._genericService.spinner = true;
    // this._modalService.close(modalId);
    console.log('closeSpecifiedModal', eve);
    // const event = eve['showErrorHandlingMsg'];
    // console.log('newEve', eve);
    this.loadingIndicator = true;
    if (eve && typeof eve === "string") {
      if (eve.includes("none") ||
        eve.includes("SUCCESS") ||
        eve.includes("NO_MAPPING") ||
        eve.includes("ERROR") ||
        eve.includes("failedSaveConsent") ||
        eve.includes("failedGetConsent")

      ) {
        this.finAppName = null;
        switch (eve) {
          // need to see how to rebuild page after this call is made...
          case "SUCCESS":
          case "NO_MAPPING":
            this._externalAccountsService.getExtAccountsData();
            break;
          case "INSTANCE_ERROR":
            this.genericError(
              "Oops! It looks like there is another FinApp session running."
            );
            this._aggregationService.emitAggDone();
            break;
          case "REFRESH_ERROR":
            this.genericError("Oops! Something went wrong syncing your data.");
            this._aggregationService.emitAggDone();
            break;
          case "failedSaveConsent":
          case "failedGetConsent":
            this.genericError();
            this._aggregationService.emitAggDone();
            break;
          default:
            this.aggProfileErrorMessage = null;
            this.loadingIndicator = false;
            break;
        }
      } else if (eve.includes("error") && eve.includes("Envestnet")) {
        this.genericError();
        this._aggregationService.emitAggDone();
      } else if (eve.includes("error") && eve.includes("logout")) {
        this.loadingIndicator = false;
        this.logOutFailed = true;
        this._aggregationService.emitAggDone();
        setTimeout(() => {
          this.logOutFailed = false;
        }, 0);
      } else {
        this.aggProfileErrorMessage = null;
        this.loadingIndicator = false;
      }
    }else{
      this.aggProfileErrorMessage = null;
        this.loadingIndicator = false;
    }
  }
}
